import { Button, ButtonProps, Stack } from '@mui/material';
import { CircularProgressWithlabel } from '../../pages/KioskUserInfoMappingPage/UserInfoPageHeader';
import { useKioskRouter } from '../../utils/useKioskRouter';

export const PrevNextButton = ({
	prevFn,
	nextFn,
	isEven = false,
	notUsingPrevBtn = false,
	nextDisabled = false,
	endIcon,
	nextLabel,
	자동돌아가기사용 = false,
}: {
	prevFn?: () => void;
	nextFn: () => void;
	isEven?: boolean;
	notUsingPrevBtn?: boolean;
	nextDisabled?: boolean;
	nextLabel?: string;
	자동돌아가기사용?: boolean;
} & ButtonProps) => {
	const buttonSize: { prev: number; next: number } = {
		prev: isEven ? 1 : 0.2,
		next: isEven || notUsingPrevBtn ? 1 : 0.8,
	};
	const { navigate홈으로 } = useKioskRouter();

	return (
		<Stack
			direction={'row'}
			spacing={2}>
			{!notUsingPrevBtn && (
				<Button
					sx={{ flex: buttonSize.prev }}
					variant='outlined'
					onClick={prevFn}
					endIcon={
						자동돌아가기사용 ? (
							<CircularProgressWithlabel
								timeout={30}
								onTimeoutCallback={navigate홈으로}
							/>
						) : undefined
					}>
					{'이전'}
				</Button>
			)}
			<Button
				type={'submit'}
				endIcon={endIcon}
				disabled={nextDisabled}
				sx={{ flex: buttonSize.next }}
				variant='contained'
				onClick={(e) => {
					e.preventDefault();
					nextFn();
				}}>
				{nextLabel ?? '다음'}
			</Button>
		</Stack>
	);
};
